<template>
  <Body class="page-list page-special page-anniversary2nd" />

  <!-- ********** Visual ********** -->
  <section class="section visual">
    <div class="wrap ani-up ani-step">
      <div class="texts">
        <div class="deco-wrap">
          <div class="deco-ribbon">
            {{ $t('스페셜') }}
          </div>
        </div>
        <h1 class="title" v-html="$t('어머니사랑의언어brspan1년의이야기span')" />
        <div class="desc">
          <div class="sub" v-html="$t('1년의이야기를열며')" />
          <p
            v-html="$t('2024년11월어머니사랑으로평화로운세상이펼쳐지기를바라며br평화를부르는어머니사랑의언어캠페인이')"
          />
          <p v-html="$t('어머니사랑이꽃피워낸사랑가득한1년의이야기br지금부터함께살펴보겠습니다')" />
        </div>
      </div>
    </div>
    <div class="circles circle-yellow" />
    <div class="circles circle-orange" />
    <div class="circles circle-pink" />
  </section>

  <!-- ********** Footprint ********** -->
  <section class="section footprint">
    <div class="wrap">
      <div class="section-title ani-step">
        <div class="theme">
          {{ $t('ourfootprints') }}
        </div>
        <h2 class="title">
          {{ $t('한눈에보는1년의기록') }}
        </h2>
        <div
          class="desc"
          v-html="$t('어머니사랑의언어가이룬1년의변화를숫자로살펴봅니다br여러분의마음이모여완성된소중한기록입니다')"
        />
      </div>

      <!-- cards -->
      <div class="stacking">
        <div class="cards">
          <div class="card country">
            <div class="card-left">
              <div class="count animCounter">
                131
              </div>
              <h3 class="title" v-html="$t('어머니사랑의언어가전해진국가')" />
            </div>
            <div class="card-right">
              <img src="/images/anniversary2nd/img_card_earth.png" alt="">
            </div>
          </div>
          <div class="card people">
            <div class="card-left">
              <div class="count animCounter">
                2181109
              </div>
              <h3 class="title" v-html="$t('일상에서어머니사랑의언어를br실천한사람들')" />
              <div class="desc">
                ({{ $t('연인원기준') }})
              </div>
            </div>
            <div class="card-right">
              <img src="/images/anniversary2nd/img_card_people.png" alt="">
            </div>
          </div>
          <div class="card check">
            <div class="card-left">
              <div class="count animCounter">
                9934041
              </div>
              <h3 class="title" v-html="$t('어머니사랑의언어7가지실천횟수')" />
              <div class="desc" v-html="$t('가장많이전해진언어는br안녕하세요206요와고마워요18입니다')" />
            </div>
            <div class="card-right">
              <img src="/images/anniversary2nd/img_card_check.png" alt="">
            </div>
          </div>
          <div class="card promo">
            <div class="card-left">
              <div class="count animCounter">
                51
              </div>
              <h3 class="title" v-html="$t('전세계참여를위해제작된br다국어홍보물의언어수')" />
              <div class="desc" v-html="$t('33개웹사이트개설언어외에도br다양한언어로제작되었습니다')" />
            </div>
            <div class="card-right">
              <img src="/images/anniversary2nd/img_card_promo.png" alt="">
            </div>
          </div>
          <div class="card poster">
            <div class="card-left">
              <div class="count animCounter">
                10341
              </div>
              <h3 class="title" v-html="$t('어머니사랑의언어포스터가br게시된횟수')" />
              <div
                class="desc"
                v-html="$t('학교직장관공서등유동인구가많은장소에서br어머니사랑의언어를알리는계기가되었습니다')"
              />
            </div>
            <div class="card-right">
              <img src="/images/anniversary2nd/img_card_poster.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ********** Posts ********** -->
  <section class="section posts">
    <div class="wrap">
      <div class="section-title ani-step">
        <div class="theme">
          {{ $t('realstories') }}
        </div>
        <h2 class="title" v-html="$t('어머니사랑이머문순간들')" />
        <div
          class="desc"
          v-html="
            $t('지난1년간어머니사랑의언어는수많은이들의마음에깊은울림을전했습니다br어머니사랑이머문그순간들은누군')
          "
        />
      </div>

      <!-- honoree -->
      <div v-if="participant.length > 0" class="part honoree">
        <div class="part-title ani-step">
          <div class="title-img">
            <img src="/images/anniversary2nd/img_thumbup.png" alt="">
          </div>
          <h2 class="title" v-html="$t('2025어머니사랑의언어span우수실천자span')" />
          <div
            class="desc"
            v-html="
              $t('2025년9월우수실천자추천공고를통해br우리주변을행복과희망평화로물들이는각국의피스메이커들이선정')
            "
          />
        </div>
        <ul class="lists list-anniversary2nd">
          <AnniversaryListItem v-for="(item, index) in participant" :key="index" :item="item" type="participant" />
        </ul>
      </div>

      <!-- contest -->
      <div v-if="contest.length > 0" class="part contest">
        <div class="part-title ani-step">
          <div class="title-img">
            <img src="/images/anniversary2nd/img_letter.png" alt="">
          </div>
          <h2 class="title" v-html="$t('2025편지후기공모전span우수작span')" />
          <div
            class="desc"
            v-html="$t('2025년5월가정의달을맞아진행된편지후기공모전을통해br61개국에서어머니사랑의언어를담은편지가약')"
          />
        </div>
        <ul class="lists list-anniversary2nd">
          <AnniversaryListItem v-for="(item, index) in contest" :key="index" :item="item" type="contest" />
        </ul>
      </div>

      <!-- review -->
      <div v-if="review.length > 0" class="part review">
        <div class="part-title ani-step">
          <div class="title-img">
            <img src="/images/anniversary2nd/img_best.png" alt="">
          </div>
          <h2 class="title" v-html="$t('홈페이지후기span하이라이트span')" />
          <div
            class="desc"
            v-html="
              $t('세계각국에서보내온어머니사랑의언어실천후기들은br많은이들의공감을얻으며새로운동참을이끌어냈습니다b')
            "
          />
        </div>
        <ul class="lists list-anniversary2nd">
          <AnniversaryListItem v-for="(item, index) in review" :key="index" :item="item" type="review" />
        </ul>
      </div>
    </div>
  </section>

  <!-- ********** Press ********** -->
  <section class="section press">
    <div class="wrap">
      <div class="section-title ani-step">
        <div class="theme">
          {{ $t('pressreports') }}
        </div>
        <h2 class="title" v-html="$t('언론이주목한br어머니사랑의언어')" />
        <div
          class="desc"
          v-html="$t('어머니사랑의언어는개인의실천을넘어br사회적공감을얻는캠페인으로언론의주목을받고있습니다')"
        />
      </div>

      <ul class="lists list-press">
        <AnniversaryPressListItem
          :media="$t('주간동아')"
          date="2025-11-21"
          link="https://weekly.donga.com/culture/article/all/11/5973151/1"
          image="/images/anniversary2nd/img_press_donga.jpg"
          :title="$t('어머니사랑깃든언어로세상을따뜻하게')"
          :desc="$t('하나님의교회평화를부르는어머니사랑의언어캠페인133개국225만여명참여')"
          :summary="$t('133개국에서전개된캠페인의확산과제1회어머니사랑의언어시상식소식을전하며일상의작은말한마디가가정과')"
          :tags="[$t('어머니사랑의언어시상식'), $t('말한마디'), $t('따뜻한변화')]"
        />
        <AnniversaryPressListItem
          :media="$t('월간중앙')"
          date="2025-07-18"
          link="https://www.m-joongang.com/news/articleView.html?idxno=401379"
          image="/images/anniversary2nd/img_press_joongang.jpg"
          :title="$t('ai에인간존중가치불어넣자국제봉사단체asezai시대의어머니마음포럼개최')"
          :desc="$t('하나님의교회대학생봉사단un본부서개최br모성적가치기반윤리적ai형성방향제시')"
          :summary="$t('un본부에서열린포럼에서어머니사랑과평화의날이소개되었으며어머니사랑이ai시대의미래기술과윤리의기준')"
          :tags="[$t('un국제포럼'), $t('어머니사랑과평화의날2'), $t('ai시대의가치')]"
        />

        <AnniversaryPressListItem
          :media="$t('문화일보')"
          date="2025-04-15"
          link="https://www.munhwa.com/article/11498955?ref=naver"
          image="/images/anniversary2nd/img_press_munhwa.jpg"
          :title="$t('내가미안해힘들었지말한마디에행복찾아와')"
          :desc="$t('어머니사랑의언어캠페인')"
          :summary="$t('갈등을겪던부부가어머니사랑의언어캠페인을통해일상을회복한사연을전하며어머니사랑의언어가관계의회복을이')"
          :tags="[$t('가정회복'), $t('부부갈등'), $t('일상속평화')]"
        />
      </ul>
    </div>
  </section>

  <!-- ********** Ending ********** -->
  <section class="section ending">
    <div class="wrap">
      <div class="texts ani-step">
        <h2 class="title" v-html="$t('지구촌에br어머니사랑으로평화가깃들기를')" />
        <div class="desc">
          <p
            v-html="$t('어머니는자녀가태어난순간부터br함께하는모든날들속에서br자녀의마음에사랑을채우고희망을심습니다')"
          />
          <p
            v-html="
              $t('어머니사랑과평화의날2주년을맞아br우리의따뜻한말과진심어린실천을통해br수많은위기와갈등에놓인지구')
            "
          />
          <p v-html="$t('지구촌에어머니사랑으로평화가깃들기를')" />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
// ---------- GSAP ----------
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const { $t } = useNuxtApp()
const { locale } = useI18n()
useHead({
  title:  `${$t('1년의이야기')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [{ rel: 'stylesheet', href: `/css/anniversary2nd.css?${useBuildTime()}` }],
})

onMounted(async () => {
  // 레이아웃 재계산을 위한 짧은 지연
  await new Promise(resolve => setTimeout(resolve, 100))
  gsap.registerPlugin(ScrollTrigger)

  // ----- Card Stacking
  const cards = gsap.utils.toArray('.card') as HTMLElement[]
  const spacer = 80
  const minScale = 0.95

  const distributor = gsap.utils.distribute({
    base: minScale,
    amount: 0.01,
  })

  cards.forEach((card, index) => {
    const isLastCard = index === cards.length - 1
    const scaleVal = isLastCard ? 1 : distributor(index, card, cards)

    gsap.to(card, {
      scale: scaleVal,
      ease: 'none',
      scrollTrigger: {
        trigger: card,
        start: 'top top+=80',
        scrub: true,
        // markers: true,
        invalidateOnRefresh: true,
      },
    })
    ScrollTrigger.create({
      trigger: card,
      start: 'top top+=70', // 100
      endTrigger: '.cards',
      end: `bottom top+=${100 + cards.length * spacer}`,
      pin: true,
      pinSpacing: false,
      // markers: true,
      id: 'pin',
      invalidateOnRefresh: true,
    })
  })

  // ----- Counter
  const animCounters = gsap.utils.toArray('.animCounter') as HTMLElement[]
  animCounters.forEach((box) => {
    gsap.from(box, {
      textContent: '0',
      duration: 1,
      ease: 'power1.inOut',
      modifiers: {
        textContent: value => formatNumber(Math.floor(value), locale.value),
      },
      scrollTrigger: {
        trigger: box,
        start: 'top 75%',
        end: '+=100',
        once: true,
        toggleActions: 'play none none reverse', // reverse
        // markers: true
      },
    })
  })

  // 스크롤 시 ani-step 하위 요소 순차 등장
  const step = gsap.utils.toArray('.ani-step > *') as HTMLElement[]
  step.forEach((box) => {
    const anim = gsap.fromTo(box, { autoAlpha: 0, y: 50 }, { duration: 0.5, autoAlpha: 1, y: 0 })
    ScrollTrigger.create({
      trigger: box,
      start: 'top 85%',
      animation: anim,
      toggleActions: 'play none complete none',
    })
  })
})

const { data } = await useFetch('/api/anniversary2nd', {
  method: 'GET',
  query: {
    languageGbSn: locale.value,
  },
  server: false,
})

const participant = computed(() => {
  return data.value?.participant ?? []
})

const contest = computed(() => {
  return data.value?.contest ?? []
})

const review = computed(() => {
  return data.value?.review ?? []
})
</script>
